import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const textOutlookMobile = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'outlook_text_mobile',
  className: 'outlook_text_mobile',
  type: 'TextOutlookMobile',
  associationType: 'TextOutlookMobile',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Microsoft Outlook web (mobile)'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showShortHeadline: true,
    showDescription: true,
    showBusinessName: true,
    showBusinessNameFirst: true,
    showAdsLabelWithBusinessName: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    previewContent: {
      border: '1px solid #C8C8C8',
      boxShadow: 'none',
      width: 340,
      height: 80,
      padding: '5px 10px 5px 15px',
    },
    businessNameWithAds: {
      display: 'block',
      color: 'black',
      textDecoration: 'none',
      fontSize: 20,
      maxWidth: 300,
      verticalAlign: 'middle',
      lineHeight: '30px',
      marginTop: 0,
      '& .adslabel': {
        backgroundColor: 'blue',
        borderRadius: 4,
        height: 15,
        verticalAlign: 'middle',
        padding: '0 4px',
        width: 'auto',
        display: 'inline-block',
        position: 'static',
        margin: '0 4px 0 0',
        fontSize: 10,
        color: 'white',
        lineHeight: '15px',
      },
    },
    shortHeadline: {
      display: 'block',
      fontSize: 13,
      marginTop: 2,
      lineHeight: '19.5px',
    },
    descriptionParent: {
      display: 'block',
      color: 'black',
      textDecoration: 'none',
      fontSize: 13,
      marginTop: 2,
      lineHeight: '19.5px',
    },
    description: {
      display: 'inline-block',
    },
  },
};

export default textOutlookMobile;
